import { Locales } from '../../../../modules/translation/messages';
import {
  formatLocaleAbreviatedNumber,
  formatPercentNumberString,
} from '../../../../utils/formatters';
import { ProgressArc } from './progress.types';

const FULL_TURN = 100;
const ABBREVIATION_SUFFIX = /[KMB]$/;

const clampToTurn = (value: number) => Math.min(Math.max(value, 0), FULL_TURN);

export const getProgressArc = (value: number): ProgressArc => {
  const percent = Math.round(value);

  if (percent <= FULL_TURN) {
    return { arcValue: clampToTurn(percent), hasCompletedTurn: false };
  }

  return { arcValue: clampToTurn(percent - FULL_TURN), hasCompletedTurn: true };
};

const getDecimalSeparator = (locale: Locales) =>
  Intl.NumberFormat(locale)
    .formatToParts(1.1)
    .find((part) => part.type === 'decimal')?.value ?? '.';

const dropAbbreviationDecimals = (abbreviated: string, locale: Locales) =>
  abbreviated.replace(new RegExp(`\\${getDecimalSeparator(locale)}\\d+`), '');

export const formatProgressLabel = (value: number, locale: Locales): string => {
  const abbreviated = formatLocaleAbreviatedNumber(Math.round(value), locale);

  if (!ABBREVIATION_SUFFIX.test(abbreviated)) {
    return formatPercentNumberString(abbreviated);
  }

  return formatPercentNumberString(dropAbbreviationDecimals(abbreviated, locale));
};
